import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import CreateMediaLog from './routes/CreateMediaLog';
import EditMediaLog from './routes/EditMediaLog';

const MediaLogFeedLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'MediaLogFeed' */ './components/MediaLogFeed')
);

export default (store) => {
	return [
		{
			path: 'home/media-log',
			element: <AsyncLoading component={<MediaLogFeedLazy />} />,
		},
		CreateMediaLog(store),
		EditMediaLog(store),
	];
};
